<template>
  <v-sheet background-color="transparent" width="100%" height="100%">
    <v-sheet
      class="d-flex justify-center align-center"
      height="100%"
      width="100%"
      color="transparent"
      v-if="loading"
    >
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-sheet>

    <v-sheet v-else background-color="transparent" width="100%" height="100%">
      <Search />
    </v-sheet>
  </v-sheet>
</template>

<script>
import Search from "./Search.vue";

export default {
  data: () => ({
    loading: true,
  }),
  mounted() {
    this.$rest(`home-config`)
      .get({
        save: (state, data) => (state.item = data),
      })
      .then(() => (this.loading = false));
  },
  components: {
    Search,
  },
};
</script>
